import React, { createContext, useState, useContext } from 'react';

// Create the context
const SideDrawerContext = createContext();

export const useSideDrawer = () => useContext(SideDrawerContext);

export const SideDrawerProvider = ({ children }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawer = () => setIsDrawerOpen(false);
    const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);

    const value = {
        isDrawerOpen,
        openDrawer,
        closeDrawer,
        toggleDrawer
    };

    return (
        <SideDrawerContext.Provider value={value}>
            {children}
        </SideDrawerContext.Provider>
    );
};
